import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Loader from '../common/ui/Loader';
import UsersService from '../../services/UsersService';

export default function Authorization (allowedRoles) {
  return WrappedComponent => {
    return class WithAuthorization extends Component {
      render () {
        if (!UsersService.isUserExists()) {
          return <div className='loader-wrapper'><Loader /></div>;
        }
        if (allowedRoles.includes(UsersService.getUserRole())) {
          return <WrappedComponent {...this.props} />;
        } else {
          return (
            <Redirect to='/' />
          );
        }
      }
    };
  };
};



// WEBPACK FOOTER //
// ./src/components/router/AuthorizationHOC.js